module.exports = new __parcel__URL__("BricksByTheBay.a1028cbc.jpeg").toString();